module.exports = function() {
  return new Worker(__webpack_public_path__ + "dd3fb8ca553033bfee80.worker.js");
};